import { Link, useParams } from "react-router-dom";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import moment from "moment";
import $ from "jquery";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { PendingOrderHistoryTable } from "./pendingOrderHistoryTable";
import { BacktoMyAccount } from "../backToMyAccount";
export const PendingOrderhistory = ({ active = true }) => {
  const [orderListData, setOrderListData] = useState(null);
  const { getPendingOrderHistory } = useGlobalFunction();
  useEffect(() => {
    if (active) loadPendingOrder();
  }, [active]);
  const loadPendingOrder = async () => {
    try {
      var response = await getPendingOrderHistory();
      if (response) setOrderListData(response);
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <Fragment>
      <section className="myAccount-section">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header">
                  <h1 className="myaccount-title">Pending Orders</h1>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="myAccountTable">
                <PendingOrderHistoryTable data={orderListData} />
              </div>
            </div>
            <BacktoMyAccount />
          </div>
        </div>
      </section>
    </Fragment>
  );
};
